import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const TimeClock16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M3.13864 3.13864C4.42795 1.84933 6.17664 1.125 8 1.125C9.82336 1.125 11.572 1.84933 12.8614 3.13864C14.1507 4.42795 14.875 6.17664 14.875 8C14.875 9.82336 14.1507 11.572 12.8614 12.8614C11.572 14.1507 9.82336 14.875 8 14.875C6.17664 14.875 4.42795 14.1507 3.13864 12.8614C1.84933 11.572 1.125 9.82336 1.125 8C1.125 6.17664 1.84933 4.42795 3.13864 3.13864ZM8 2.625C6.57446 2.625 5.20731 3.19129 4.1993 4.1993C3.19129 5.20731 2.625 6.57446 2.625 8C2.625 9.42554 3.19129 10.7927 4.1993 11.8007C5.20731 12.8087 6.57446 13.375 8 13.375C9.42554 13.375 10.7927 12.8087 11.8007 11.8007C12.8087 10.7927 13.375 9.42554 13.375 8C13.375 6.57446 12.8087 5.20731 11.8007 4.1993C10.7927 3.19129 9.42554 2.625 8 2.625ZM8 5.0625C8.41421 5.0625 8.75 5.39829 8.75 5.8125V7.68939L11.2645 10.2044C11.5573 10.4973 11.5573 10.9722 11.2644 11.2651C10.9714 11.5579 10.4966 11.5579 10.2037 11.2649L7.46961 8.53027C7.329 8.38963 7.25 8.19888 7.25 8V5.8125C7.25 5.39829 7.58579 5.0625 8 5.0625Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
